module.exports = __webpack_public_path__ + "img/03.a6d0e090.png";